
import React, { useState, useEffect } from "react";

import { authKey, GET_FINANCIAL_YEAR, CREATE_MANUAL_PO, GET_APPROVED_STAKEHOLDERS, UPLOAD_DCUMENT, GET_PLANNING_NUMBER_LIST, GET_GROWER_LAND_LIST, GET_OTHER_PLANNING_NUMBER, GET_PO_TAX_CALCULATION, GET_MAPPED_GROWER_PO_FOR_HIT_MANUAL_PO, CREATE_HIT_MANUAL_PO, GET_MAPPED_PLANNING_NUMBER_LIST, GET_UNRESTRICTED_INVENTORY, FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN, RB_CB_RATIO, GET_TAX_DETAILS, GET_PO_PREVIEW, GET_DISTANCE_TRAVELLED, GET_AVERAGE_DISTANCE, CREATE_STOCK_TRANSFER_REQUEST, CREAT_SPOT_BIDDING_REQUEST } from '../../../common/URLs';
import { toast } from 'react-toastify';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { Typography, Container, Card, CardContent, Box, Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText, Autocomplete, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { useNavigate } from "react-router-dom";
import { FileUploadMUI } from "../../../common/fileUpload/fileUploadMUI";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import { AddIcon, PreviewIcon, SubmitIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import axios from "axios";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

export function SpotBiddingRequest() {
  const [financialYearList, setFinancialYearList] = useState([]);
  const [urnList, setUrnList] = useState([]);
  const [destinationUrnList, setDestinationUrnList] = useState([]);
  const [sourceUrnList, setSourceUrnList] = useState([]);
  const [poStakeholderType, setPoStakeholderType] = useState('');
  const [poStakeholderUrn, setPoStakeholderUrn] = useState('');
  const [createResponse, setCreateResponse] = useState();
  const [urnListNonTransporter, setUrnListNonTransporter] = useState([]);
  const [uploadDocResponse, setUploadDocResponse] = useState();

  const [planningNumber, setPlanningNumber] = useState();
  const [otherPlanningNumber, setOtherPlanningNumber] = useState();
  const [poType, setPoType] = useState('');
  const [materialType, setMaterialType] = useState('');
  const [inventoryLevel, setInventoryLevel] = useState('');

  const [financialYear, setFinancialYear] = useState();
  const [monthChange, setMonthChange] = useState();
  const [selectedLandId, setSelectedLandId] = useState();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isApiCalled, setIsApiCalled] = useState(false);

  const [spotAllotmentQty, setSpotAllotmentQty] = useState();
  const [baseBidPrice, setBaseBidPrice] = useState();
  const [distanceTravelled, setDistanceTravelled] = useState('');

  const [documentsArray, setDocumentsArray] = useState([]);

  const [distinctDestinationUrnValues, setDistinctDestinationUrnValues] = useState([]);
  const [destinationStakeholderUrn, setDestinationStakeholderUrn] = useState('');
  const [destinationStakeholderType, setDestinationStakeholderType] = useState('');

  const [distinctSourceUrnValues, setDistinctSourceUrnValues] = useState([]);
  const [sourceStakeholderUrn, setSourceStakeholderUrn] = useState('');
  const [sourceStakeholderType, setSourceStakeholderType] = useState('');

  const [rbRbRation, setRbRbRation] = useState();
  const [getTaxDetails, setGetTaxDetails] = useState('');

  const [confirmOpen2, setConfirmOpen2] = useState(false);
  const handleConfirmOpen2 = () => setConfirmOpen2(true);
  const handleConfirmClose2 = () => setConfirmOpen2(false);

  const [biddingDates, setBiddingDates] = useState({
    "biddingStartDate": null,
    "biddingEndDate": null
  })

  const [errorMessage, setErrorMessage] = useState({
    "poDescriptionError": "",
    "poMaterialTypeError": "",
    "poTypeError": "",
    "serviceStakeholderTypeError": "",
    "poStakeholderTypeError": "",
    "poStakeholderUrnError": "",
    "poQuantityError": '',
    "financialYearError": "",
    "monthError": "",
    "planningNumberError": "",
    "landNameError": "",
    "isOtherPlanningNumber": "",
    "isShortCloseError": "",
    "searchUrnError": "",
    "totalShortCloseQtyError": "",
    "noPoSelectedError": "",
    "poShortCloseQuantityError": "",
    "growerPoDuplicateError": "",
    "destinationStakeholderUrnError": "",
    "destinationStakeholderTypeError": "",
    "sourceStakeholderUrnError": "",
    "sourceStakeholderTypeError": "",
    "distanceTravelledError": "",
    "basePriceError": "",
    "biddingStartDateError": "",
    "biddingEndDateError": "",
    "fileError": ""
  });

  useEffect(() => {
    getFinancialYearApi();
  }, []);

  const getFinancialYearApi = () => {
    loaderService.showLoader();
    apiClient.post(GET_FINANCIAL_YEAR,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        setFinancialYearList(response.data?.financialYearLst);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const sortedYears = financialYearList?.sort((a, b) => {
    const yearA = parseInt(a.split('-')[0]);
    const yearB = parseInt(b.split('-')[0]);
    return yearA - yearB;
  });

  useEffect(() => {
    if (poStakeholderType) {
      onStakeholderTypeChange();
    }

  }, [poStakeholderType]);

  const onStakeholderTypeChange = () => {
    loaderService.showLoader();
    apiClient.post(GET_APPROVED_STAKEHOLDERS,
      {
        "type": poStakeholderType
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        setUrnList(response.data.stakeHolders);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onFinancialYearChange = (e) => {
    setFinancialYear(e.target.value);
    setErrorMessage({ ...errorMessage, financialYearError: "" });
  }

  const onMonthChange = (e) => {
    setMonthChange(e.target.value);
    setErrorMessage({ ...errorMessage, monthError: "" });
  }

  const onTypeChange = (e) => {
    setPoStakeholderType(e.target.value);
    setErrorMessage({ ...errorMessage, poStakeholderTypeError: "" });
    setMaterialType('');
    setPoType('');
    setSearchTerm('');
    setDestinationStakeholderType('');
    setDestinationStakeholderUrn('');
    setSourceStakeholderType('');
    setSourceStakeholderUrn('');
    setSpotAllotmentQty('');
    setGetTaxDetails('');
    setInventoryLevel('');
    setDistanceTravelled('');            //for initial values                     
  }

  const onPoMaterialTypeChange = (e) => {
    setMaterialType(e.target.value);
    setErrorMessage({ ...errorMessage, poMaterialTypeError: "" });

  }

  // const onConfirmSubmit = (e) => {
  //   handleConfirmClose2();
  //   onHitPOCreationSbmit(e);
  // }

   
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await onHitPOCreationSbmit();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen2(false);
            setIsApiCalled(false);
        }
    };

  const onSubmitButtonClick = (e) => {
    handleConfirmOpen2();
  }

  const onHitPOCreationSbmit = (e) => {
    createSpotBiddingRequest();
  }

  const onSubmit = (e) => {
    if (!financialYear) {
      setErrorMessage({ ...errorMessage, financialYearError: "Please Select Financial Year" })
    }
    else if (!monthChange) {
      setErrorMessage({ ...errorMessage, monthError: "Please Select Month" })
    }
    else if (!materialType) {
      setErrorMessage({ ...errorMessage, poMaterialTypeError: "Please Select Material Type" })
    }
    // else if (!biddingDates?.biddingStartDate) {
    //   setErrorMessage({ ...errorMessage, biddingStartDateError: "Please Select Bidding Start Date" })
    // }
    // else if (!biddingDates?.biddingEndDate) {
    //   setErrorMessage({ ...errorMessage, biddingEndDateError: "Please Select Bidding End Date" })
    // }
    else if (!spotAllotmentQty) {
      setErrorMessage({ ...errorMessage, poQuantityError: "Spot Allotment Quantity should be more than 0" })
    }
    else if (!baseBidPrice) {
      setErrorMessage({ ...errorMessage, basePriceError: "Base Bid Price should be more than 0" })
    }
    else if (!sourceStakeholderType) {
      setErrorMessage({ ...errorMessage, sourceStakeholderTypeError: "Please select Source Type" })
    }
    else if (!sourceStakeholderUrn) {
      setErrorMessage({ ...errorMessage, sourceStakeholderUrnError: "Please select Source URN" })
    }
    else if (!destinationStakeholderType) {
      setErrorMessage({ ...errorMessage, destinationStakeholderTypeError: "Please select Destination Type" })
    }
    else if (!destinationStakeholderUrn) {
      setErrorMessage({ ...errorMessage, destinationStakeholderUrnError: "Please select Destination URN" })
    }
    // else if (poStakeholderType === "Transporter" && !distanceTravelled) {
    //   setErrorMessage({ ...errorMessage, distanceTravelledError: "Distance Travelled should be more than 0" })
    // }
    else if (sourceStakeholderUrn === destinationStakeholderUrn) {
      toast.error("Source Stakeholder URN and Destination Stakeholder URN should not be same!")
    }
    // else if (documentsArray?.length === 0) {
    //   setErrorMessage({ ...errorMessage, fileError: "Please Upload Bidding Terms Document" })
    // }
    else {
      onSubmitButtonClick();
    }

  }

  const getDistanceTravelled = (sourceUrn, destinationUrn) => {
    loaderService.showLoader();
    apiClient
      .post(
        GET_DISTANCE_TRAVELLED,
        {
          "sourceURN": sourceUrn,
          "sourceType": sourceStakeholderType,
          "growerLandId": poStakeholderType === "Grower" ? selectedLandId : null,
          "destinationURN": destinationUrn,
          "destinationType": destinationStakeholderType,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
            AuthKey: authKey,
          }
        }
      )
      .then((response) => {
        setDistanceTravelled(response.data.distanceInKM);
        if (response.data.distanceInKM > 0) {
          setErrorMessage({ ...errorMessage, distanceTravelledError: "" });
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  const getAverageDistance = (sourceUrn, destinationUrn, planningNo) => {
    loaderService.showLoader();
    apiClient
      .post(
        GET_AVERAGE_DISTANCE,
        {
          "hitURN": searchTerm,
          "financialYear": financialYear,
          "month": monthChange,
          "planningNumber": planningNo,
          "destinationStakeholderType": destinationStakeholderType,
          "destinationStakeholderUrn": destinationUrn
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
            AuthKey: authKey,
          }
        }
      )
      .then((response) => {
        loaderService.hideLoader();
        setDistanceTravelled(response.data.distanceInKM)
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };
  // console.log("distance", distanceTravelled)
  useEffect(() => {
    if (createResponse) {
      if (createResponse.isSuccess === true) {
        toast.success(createResponse?.message);
        setFinancialYear('');
        setMonthChange('');
        setMaterialType('');
        setDestinationStakeholderType('');
        setDestinationStakeholderUrn('');
        setSourceStakeholderType('');
        setSourceStakeholderUrn('');
        setSpotAllotmentQty('');
        setBaseBidPrice('');
        setDistanceTravelled('');
        setBiddingDates({
          "biddingStartDate": null,
          "biddingEndDate": null
        })
        setDocumentsArray([]);
      }
      else {
        toast.error(createResponse?.message ? createResponse?.message : "Error")
      }
    }
  }, [createResponse]);

  const createSpotBiddingRequest = () => {
    loaderService.showLoader();
    apiClient
      .post(
        CREAT_SPOT_BIDDING_REQUEST,
        {
          "materialType": materialType,
          "allotmentQuantity": spotAllotmentQty,
          "sourceStakeholderType": sourceStakeholderType,
          "sourceStakeholderUrn": sourceStakeholderUrn,
          "destinationStakeholderType": destinationStakeholderType,
          "destinationStakeholderUrn": destinationStakeholderUrn,
          // "biddingTermsFileId": documentsArray?.find((item) => item.documentType === "biddingTermsFile")?.documentBlobName,
          // "biddingTermsFileName": documentsArray?.find((item) => item.documentType === "biddingTermsFile")?.documentName,
          "distanceTravelled": distanceTravelled,
          "financialYear": financialYear,
          "month": monthChange,
          "baseBidPrice": baseBidPrice,
          // "biddingStartDate": biddingDates?.biddingStartDate,
          // "biddingEndDate": biddingDates?.biddingEndDate
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setCreateResponse(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  useEffect(() => {
    if (uploadDocResponse) {
      if (uploadDocResponse.isSuccess === true) {
        toast.success(uploadDocResponse?.message)
      }
      else {
        toast.error(uploadDocResponse?.message ? uploadDocResponse?.message : "Error")
      }
    }
  }, [uploadDocResponse]);

  const urns = urnList?.map(item => item?.urn);

  const handleSearch = (query) => {
    const results = urns.filter(urn =>
      urn && query && urn.toLowerCase().includes(query.toLowerCase())
    );
    setSearchResults(results);
  };

  const onAllotmentQtyChange = (e) => {
    setSpotAllotmentQty(e.target.value.slice(0, 10))
    setErrorMessage({ ...errorMessage, poQuantityError: "" });
  }

  const onBaseBidPriceChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setBaseBidPrice(value);
    }
    // setBaseBidPrice(value);
    setErrorMessage({ ...errorMessage, basePriceError: "" });
  }

  const onDistanceTravelledChange = (e) => {
    setDistanceTravelled(e.target.value.slice(0, 10))
    setErrorMessage({ ...errorMessage, distanceTravelledError: "" });
  }

  const getUnrestrictedInventory = (selectedUrn) => {
    loaderService.showLoader();
    apiClient.post(GET_UNRESTRICTED_INVENTORY,
      {
        "stakeHolderUrn": selectedUrn,
        "stakeHolderType": poStakeholderType
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        setInventoryLevel(response.data.inventoryMovementSum);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const ExpectedChipQuantity = inventoryLevel?.unrestrictedRBInventory ? Number((inventoryLevel?.unrestrictedRBInventory / rbRbRation).toFixed(2)) : 0

  // useEffect(() => {
  //   if (destinationStakeholderType) {
  //     onDestinationStakeholderTypeChange();
  //   }
  // }, [destinationStakeholderType]);

  // useEffect(() => {
  //   if (sourceStakeholderType) {
  //     onSourceStakeholderTypeChange();
  //   }
  // }, [sourceStakeholderType]);

  const onDestinationStakeholderTypeChange = () => {
    loaderService.showLoader();
    apiClient.post(FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN,
      {
        "stakeholderType": poStakeholderType,
        "stakeholderUrn": searchTerm
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        if (destinationStakeholderType === "LLE") {
          setDestinationUrnList(response.data.llleMappedPojo);
        }
        if (destinationStakeholderType === "Interim Storage Operator") {
          setDestinationUrnList(response.data.isMappedPojo)
        }
        if (destinationStakeholderType === "Plant") {
          setDestinationUrnList(response.data.plantMappedPojo);
        }

        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onSourceStakeholderTypeChange = () => {
    loaderService.showLoader();
    apiClient.post(FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN,
      {
        "stakeholderType": poStakeholderType,
        "stakeholderUrn": searchTerm
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        if (sourceStakeholderType === "LLE") {
          setSourceUrnList(response.data.llleMappedPojo);
        }
        if (sourceStakeholderType === "Interim Storage Operator") {
          setSourceUrnList(response.data.isMappedPojo)
        }
        if (sourceStakeholderType === "Plant") {
          setSourceUrnList(response.data.plantMappedPojo);
        }

        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  useEffect(() => {
    const uniqueValues = Array.from(new Set(destinationUrnList?.map(item => item.stakeholderUrn)));
    const distinctObjects = uniqueValues?.map(value => { return destinationUrnList.find(item => item.stakeholderUrn === value); });
    setDistinctDestinationUrnValues(distinctObjects);
  }, [destinationUrnList]);

  useEffect(() => {
    const uniqueValues = Array.from(new Set(sourceUrnList?.map(item => item.stakeholderUrn)));
    const distinctObjects = uniqueValues?.map(value => { return sourceUrnList.find(item => item.stakeholderUrn === value); });
    setDistinctSourceUrnValues(distinctObjects);
  }, [sourceUrnList]);

  const onDestinationTypeChange = (e) => {
    setDestinationStakeholderType(e.target.value);
    setErrorMessage({ ...errorMessage, destinationStakeholderTypeError: "" });
    setDestinationStakeholderUrn("");
    setDestinationUrnList([]);
    getSourceDestinationUrnList(e.target.value);
  }


  const onSourceTypeChange = (e) => {
    setSourceStakeholderType(e.target.value);
    setErrorMessage({ ...errorMessage, sourceStakeholderTypeError: "" });
    setSourceStakeholderUrn("");
    setSourceUrnList([]);
    getSourceDestinationUrnList(e.target.value);
  }

  const onDestinationUrnChange = (e) => {
    setDestinationStakeholderUrn(e.target.value);
    poStakeholderType === "Transporter" && getDistanceTravelled(sourceStakeholderUrn, e.target.value);
    setErrorMessage({ ...errorMessage, destinationStakeholderUrnError: "" });
  }

  // const onSourceUrnChange = (e) => {
  //   setSourceStakeholderUrn(e.target.value);
  //   destinationStakeholderUrn && poStakeholderType === "Transporter" && getDistanceTravelled(e.target.value, destinationStakeholderUrn);
  //   setErrorMessage({ ...errorMessage, sourceStakeholderUrnError: "" });
  // }

  const onUploadCallBack = (docArray) => {
    setDocumentsArray(docArray);
    setErrorMessage({ ...errorMessage, fileError: "" })
  }

  useEffect(() => {
    getRbCbRatio();
  }, []);

  const getRbCbRatio = () => {
    loaderService.showLoader();
    apiClient.post(RB_CB_RATIO,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        setRbRbRation(response.data?.value);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  // useEffect(() => {
  //     getTaxData();
  // }, []);

  const getTaxData = (stakeholderUrn) => {
    loaderService.showLoader();
    apiClient.post(GET_TAX_DETAILS,
      {
        "stakeholderUrn": stakeholderUrn,
        "stakeholderType": poStakeholderType,
        "poActivityType": ""
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        setGetTaxDetails(response.data);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getSourceDestinationUrnList = (urn) => {
    loaderService.showLoader();
    axios.post(GET_APPROVED_STAKEHOLDERS,
      {
        "type": urn
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        setUrnListNonTransporter(response.data.stakeHolders?.map(item => item?.urn));
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onSourceUrnChangeNonTransporter = (e, value) => {
    setSourceStakeholderUrn(value);
    destinationStakeholderUrn && getDistanceTravelled(value, destinationStakeholderUrn);
    setErrorMessage({ ...errorMessage, sourceStakeholderUrnError: "" });
  }

  const onDestinationUrnChangeNonTransporter = (e, value) => {
    setDestinationStakeholderUrn(value);
    sourceStakeholderUrn && getDistanceTravelled(sourceStakeholderUrn, value);
    setErrorMessage({ ...errorMessage, destinationStakeholderUrnError: "" });
  }

  const handleDateChange = (e, dateField) => {
    setBiddingDates({ ...biddingDates, [dateField]: e.format("YYYY-MM-DD") })
    if (dateField === "biddingStartDate") {
      setErrorMessage({ ...errorMessage, biddingStartDateError: "" });
    }
    if (dateField === "biddingEndDate") {
      setErrorMessage({ ...errorMessage, biddingEndDateError: "" });
    }
  }

  return (
    <>
      <Container maxWidth="xxl">
        <Typography variant="h4" sx={{ mb: 1 }}>
          Spot Bidding Allotment Request
        </Typography>
        <Card>
          <CardContent>
            <Grid container spacing={1} direction="row">
              {/* <Grid item xs={12}>
                <Grid container spacing={3}>

                  <Grid item xs={12} lg={3}>
                                        <FormControl fullWidth size="small" required error={errorMessage.poStakeholderTypeError}>
                                            <InputLabel>Stakeholder Type</InputLabel>
                                            <Select label="Stakeholder Type" name="poStakeholderType" value={poStakeholderType || ''} onChange={(e) => onTypeChange(e)}>
                                                <MenuItem value="Transporter">Transporter</MenuItem>
                                                <MenuItem value="Non Transporter">Non Transporter</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.poStakeholderTypeError}</FormHelperText>
                                        </FormControl>
                                    </Grid>


                </Grid>
              </Grid>
              <Grid item xs={12} mt={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} lg={6}>
                    <FileUploadMUI key="stockTransferSupportingDoc"
                      documentList={documentsArray}
                      documentType="stockTransferSupportingDoc"
                      callBackDocumentUpload={onUploadCallBack}
                      title="Upload Supporting Document"
                      containerName="pit"
                      errorMessage={errorMessage}
                      setErrorMessage={setErrorMessage}
                      documentError="fileError"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Divider sx={{
                width: '105%',
                bgcolor: 'black',
                marginTop: '3vh'
              }} mt={2} /> */}

              <Grid item xs={12}>
                <Grid container spacing={3}>
                  {/* <Grid item xs={12} lg={4}>
                                        <Autocomplete
                                            value={searchTerm}
                                            onChange={(_, newValue) => {
                                                setSearchTerm(newValue);
                                                handleSearch(newValue);
                                                newValue && getUnrestrictedInventory(newValue);
                                                getTaxData(newValue);
                                                setDestinationStakeholderType('');
                                                setDestinationStakeholderUrn('');
                                                setDestinationUrnList([]);
                                                setSourceStakeholderType('');
                                                setSourceStakeholderUrn('');
                                                setSourceUrnList([]);
                                                // setGetTaxDetails('');
                                                // setInventoryLevel('');
                                                setErrorMessage({ ...errorMessage, searchUrnError: "" });
                                            }}
                                            options={urns || []} // Ensure options is an array, even if it's initially undefined
                                            renderInput={(params) => (
                                                <TextField {...params} label="Search URN" variant="outlined" fullWidth size="small"
                                                    required error={errorMessage.searchUrnError} helperText={errorMessage.searchUrnError} />
                                            )}
                                            disabled={poStakeholderType === "Non Transporter"}
                                        />
                                    </Grid> */}
                  {/* <Grid item xs={12} lg={4} hidden={!(poStakeholderType === "LLE")}>
                                        <TextField fullWidth size="small"
                                            disabled
                                            label="Inventory Level"
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            value={searchTerm ? (materialType === "rawbamboo" ? inventoryLevel.unrestrictedRBInventory : materialType === "chipbamboo" ? inventoryLevel.unrestrictedCBInventory : '') : ''} />
                                    </Grid> */}
                  {/* <Grid item xs={12} lg={4} hidden={!(poStakeholderType === "LLE")}>
                                        <TextField fullWidth size="small"
                                            disabled
                                            hidden={materialType === "chipbamboo"}
                                            label="Inventory Expected Chip Quantity"
                                            value={materialType === "rawbamboo" ? ExpectedChipQuantity : 0}
                                        />
                                    </Grid> */}
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth size="small" required error={errorMessage.financialYearError}>
                      <InputLabel>Financial Year</InputLabel>
                      <Select label="Financial Year" value={financialYear || ''} name="financialYear" onChange={(e) => onFinancialYearChange(e)}>
                        <MenuItem><em>Financial Year</em></MenuItem>
                        {sortedYears &&
                          sortedYears.map((items) => (
                            <MenuItem value={items}>{items}</MenuItem>
                          ))}
                      </Select>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.financialYearError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth size="small" required error={errorMessage.monthError}>
                      <InputLabel>Month</InputLabel>
                      <Select required label="Month" value={monthChange || ''} name="month" onChange={(e) => onMonthChange(e)}>
                        <MenuItem><em>Month</em></MenuItem>
                        <MenuItem value="Jan">January</MenuItem>
                        <MenuItem value="Feb">February</MenuItem>
                        <MenuItem value="Mar">March</MenuItem>
                        <MenuItem value="Apr">April</MenuItem>
                        <MenuItem value="May">May</MenuItem>
                        <MenuItem value="Jun">June</MenuItem>
                        <MenuItem value="Jul">July</MenuItem>
                        <MenuItem value="Aug">August</MenuItem>
                        <MenuItem value="Sep">September</MenuItem>
                        <MenuItem value="Oct">October</MenuItem>
                        <MenuItem value="Nov">November</MenuItem>
                        <MenuItem value="Dec">December</MenuItem>
                      </Select>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.monthError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth size="small" required error={errorMessage.poMaterialTypeError}>
                      <InputLabel>Material Type</InputLabel>
                      <Select label="Material Type" name="materialType" value={materialType || ''} onChange={(e) => onPoMaterialTypeChange(e)}>
                        <MenuItem><em>Material Type</em></MenuItem>
                        {/* <MenuItem value="rawbamboo">Raw Bamboo</MenuItem> */}
                        <MenuItem value="chipbamboo">Chip Bamboo</MenuItem>
                      </Select>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.poMaterialTypeError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  {/* <Grid item xs={12} lg={4}>
                    <FormControl fullWidth >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Bid Start Date"
                          inputFormat="DD/MM/YYYY"
                          name="biddingStartDate"
                          value={biddingDates.biddingStartDate}
                          onChange={(e) => { handleDateChange(e, "biddingStartDate") }}
                          renderInput={(params) => <TextField size="small" {...params} error={errorMessage.biddingStartDateError} helperText={errorMessage.biddingStartDateError} />}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Bid End Date"
                          inputFormat="DD/MM/YYYY"
                          name="biddingEndDate"
                          value={biddingDates.biddingEndDate}
                          onChange={(e) => { handleDateChange(e, "biddingEndDate") }}
                          renderInput={(params) => <TextField size="small" {...params} error={errorMessage.biddingEndDateError} helperText={errorMessage.biddingEndDateError} />}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid> */}
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth required size="small"
                      error={errorMessage.poQuantityError}
                      helperText={errorMessage.poQuantityError}
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      // name="spotAllotmentQty"
                      label="Allotment Quantity(MT)"
                      value={spotAllotmentQty || ''}
                      onChange={(e) => onAllotmentQtyChange(e)}
                      onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')' || evt.key === 'e') && evt.preventDefault()}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth required size="small"
                      error={errorMessage.basePriceError}
                      helperText={errorMessage.basePriceError}
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      // name="spotAllotmentQty"
                      label="Base Bid Price"
                      value={baseBidPrice || ''}
                      onChange={(e) => onBaseBidPriceChange(e)}
                      inputProps={{ step: '0.01' }}
                      onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')' || evt.key === 'e') && evt.preventDefault()}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth size="small" required error={errorMessage.sourceStakeholderTypeError}>
                      <InputLabel>Source Stakeholder Type</InputLabel>
                      <Select label="Source Stakeholder Type" name="sourceStakeholderType" value={sourceStakeholderType || ''} onChange={(e) => onSourceTypeChange(e)}>
                        <MenuItem value="LLE">LLE</MenuItem>
                        <MenuItem value="InterimStorageOperator">IS</MenuItem>
                      </Select>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.sourceStakeholderTypeError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <Autocomplete
                      id="combo-box-demo"
                      options={urnListNonTransporter?.map((item) => item) ? urnListNonTransporter?.map((item) => item) : []}
                      sx={{ width: '100%' }}
                      size='small'
                      value={sourceStakeholderUrn}
                      onChange={(e, newInputValue) => onSourceUrnChangeNonTransporter(e, newInputValue)}
                      renderInput={(params) => <TextField {...params} label="Source Stakeholder URN" error={errorMessage.sourceStakeholderUrnError} helperText={errorMessage.sourceStakeholderUrnError} />}
                    />

                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <FormControl fullWidth size="small" required error={errorMessage.destinationStakeholderTypeError}>
                      <InputLabel>Destination Stakeholder Type</InputLabel>
                      <Select label="Desination Stakeholder Type" name="secondPartyType" 
                      value={destinationStakeholderType || ''} onChange={(e) => onDestinationTypeChange(e)}>
                        <MenuItem value="LLE">LLE</MenuItem>
                        <MenuItem value="InterimStorageOperator">IS</MenuItem>
                        <MenuItem value="Plant">Plant</MenuItem>
                      </Select>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.destinationStakeholderTypeError}</FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} lg={4}>
                    <Autocomplete
                      id="combo-box-demo"
                      options={urnListNonTransporter?.map((item) => item) ? urnListNonTransporter?.map((item) => item) : destinationStakeholderType === "Plant" ? ["ABEPL"] : []}
                      sx={{ width: '100%' }}
                      size='small'
                      value={destinationStakeholderUrn}
                      onChange={(e, newInputValue) => onDestinationUrnChangeNonTransporter(e, newInputValue)}
                      renderInput={(params) => <TextField {...params} label="Destination Stakeholder URN" error={errorMessage.destinationStakeholderUrnError} helperText={errorMessage.destinationStakeholderUrnError} />}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4} hidden={poStakeholderType === "Non Transporter"}>
                    <TextField fullWidth required size="small"
                      error={errorMessage.distanceTravelledError}
                      helperText={errorMessage.distanceTravelledError}
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      name="distanceTravelled"
                      label="Distance Travelled(in KM)"
                      value={distanceTravelled || ''}
                      onChange={(e) => onDistanceTravelledChange(e)}
                      onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')' || evt.key === 'e') && evt.preventDefault()}
                    />
                  </Grid>
                  {/* <Grid item xs={12} lg={6}>
                    <FileUploadMUI key="biddingTermsFile"
                      documentList={documentsArray}
                      documentType="biddingTermsFile"
                      callBackDocumentUpload={onUploadCallBack}
                      title="Upload Bidding Terms Document*"
                      containerName="pit"
                      errorMessage={errorMessage}
                      setErrorMessage={setErrorMessage}
                      documentError="fileError"
                    />
                  </Grid> */}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }} >
          <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onSubmit(e)} endIcon={<SubmitIcon />}>Submit</Button>
        </Box>
      </Container>
      <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmSubmit} onClose={handleConfirmClose2} action="Submit" />

    </>
  )
}